import { render, staticRenderFns } from "./app.vue?vue&type=template&id=5d87e7ea"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d87e7ea')) {
      api.createRecord('5d87e7ea', component.options)
    } else {
      api.reload('5d87e7ea', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=5d87e7ea", function () {
      api.rerender('5d87e7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/app.vue"
export default component.exports